// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__6v7J7"};